import { useTranslation } from 'react-i18next';

export default function Dashboard() {
  const { t } = useTranslation();
  return (
    <>
      <div className="page-header"><h1>{t('nav.dashboard')}</h1></div>
      <div className="card empty">
        Dashboard placeholder — outstanding, aging, revenue widgets land in Phase 10.
      </div>
    </>
  );
}
